import React, { useMemo } from 'react';
import { RepeatedVirtualSlotsPlaceholderContext, } from './slotsPlaceholderContext';
import { extractSlotPreviewState, } from './utils/extractSlotPreviewState';
export function withRepeatedSlotsPlaceholders(Component) {
    return (props) => {
        const { getSlotByItemId, compPreviewState, id, ...otherProps } = props;
        const slotPreviewState = useMemo(() => extractSlotPreviewState(compPreviewState), [compPreviewState]);
        return (React.createElement(RepeatedVirtualSlotsPlaceholderContext.Provider, { value: {
                getSlotByItemId,
                slotPreviewState,
                hostId: id,
            } },
            React.createElement(Component, { ...otherProps })));
    };
}
//# sourceMappingURL=withRepeatedSlotsPlaceholders.js.map